<template>
  <div v-wechat-title="brandTitle" class="classify-page">
    <PageBack style="margin-top: 6px;"/>

    <div class="content-box">
      <div class="box1">
        <form action="/search">
          <van-search v-model="keyword" placeholder="输入关键字搜索商品 `" shape="round" @search="searchGoods" style="padding-left: 40px;"/>
        </form>
      </div>

      <div class="box2">
        <div class="detail">
          <van-image v-if="adsImage" :src="adsImage" lazy-load style="padding: 8px; text-align: center"
            width="80"></van-image>
          <div style="text-align: left">
            {{ brandDetail }}
          </div>
        </div>

        <van-empty v-if="!(goodsList && goodsList.length > 0)" description="还没有商品上架..."></van-empty>

        <div class="goods-box">
          <van-list v-model="loading" :error.sync="error" :finished="finished" :finished-text="finishedText" :offset="100"
            error-text="请求失败，点击重新加载 C" @load="getGoodsByBrandName">
            <div v-for="item of goodsList" :key="item.id" class="goods-item flex-row col-center mt5">
              <goods-unit :cate-code="item.cateCode" :goods-id="item.id" :goods-type="item.goodsType"
                :head-image="item.headImage" :name="item.name" :price="item.price" :sale-count="item.sale"
                :spec="item.spec"
                :supplier-id="item.supplierId" />
            </div>
          </van-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue"
import { getBrandById, api_get_goods_list_by_brand_id } from "@/api/goods-api"
import GoodsUnit from "@/components/common/goods-unit"
import { Lazyload } from "vant"

Vue.use(Lazyload)

export default {
  name: "index",
  components: { GoodsUnit },

  data() {
    return {
      keyword: "",
      goodsList: [],
      brandId: 0,
      brandTitle: "",
      adsImage: "",
      brandDetail: "",
      pi: 0,
      ps: 10,
      error: false,
      loading: false,
      finished: false,
      finishedText: "没有更多了 F",
    }
  },

  created() {
    this.brandId = this.$route.query.brandId || 0;
    this.cateId = this.$route.query.cateId || 0;

    getBrandById(this.brandId).then((res) => {
      this.brandTitle = res.data.name;
      this.adsImage = res.data.headImage;
      this.brandDetail = res.data.detail;
    })
  },

  methods: {
    searchGoods() {
      this.pi = 0
      this.goodsList = []
      this.getGoodsByBrandName()
    },

    getGoodsByBrandName() {
      this.finishedText = "加载中 B ...";
      this.pi++;

      api_get_goods_list_by_brand_id(
        this.$store.getters.city_code,
        this.brandId,
        this.cateId,
        this.pi,
        this.ps,
        this.keyword
      ).then((res) => {
          budo_log.debug('#97 api_get_goods_list_by_brand_id', this.keyword, this.pi)

          let reslut = res.data.records.map((item) => {
            return {
              id: item.goodsId,
              name: item.name,
              price: item.price,
              sale: item.saleCount,
              headImage: item.headImage,
              spec: item.spec,
              cateCode: item.cateCode,
              goodsType: item.goodsType,
              supplierId: item.supplierId
            };
          });

          this.goodsList = this.goodsList.concat(reslut);
          this.loading = false;

          // 后端默认不查总数(total 恒为 0)，按本次返回条数是否不足一页判断是否到底
          if (res.data.records.length < this.ps) {
            this.finished = true;
            this.finishedText =
              this.goodsList.length === 0 ? "看看其它的吧 A" : "没有更多了 G";
          }
        }).catch((error) => {
          budo_log.info("#119 api_get_goods_list_by_brand_id", error)

          this.loading = false;
          this.error = true;
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "index";
</style>
